import React from "react";
import "./howitworks.css";
import arrowTop from "../../assets/HowItWorks/arrow-to-top-right.svg";
import arrowBottom from "../../assets/HowItWorks/arrow-to-bottom-right.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
export default function HowItWorks() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const howitworkspoints = [
    {
      heading: "Assess Risks Instantly",
      paragraph: "Identify AI threats early with real-time risk analysis.",
    },
    {
      heading: "Secure Every Layer",
      paragraph:
        "Implement multi-layered protection across AI models, data, and infrastructure.",
    },
    {
      heading: "Monitor in Real-Time",
      paragraph:
        "Track AI behavior and detect emerging threats with continuous monitoring.",
    },
    {
      heading: "Automate Compliance",
      paragraph:
        "Ensure seamless security adherence with automated AI governance.",
    },
  ];

  return (
    <section
      className={`how-it-works-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Implementation</span>
          </div>
          <div className="heading-description">
            <h2>Securing AI with SAIF: A Step-by-Step Approach </h2>
            <p>
              A streamlined process to assess risks, secure AI systems, monitor
              threats in real-time, and ensure automated compliance.
            </p>
          </div>
        </div>
        <div className="section-content-wrapper">
          <div className="how-it-works-points row">
            <div className="col-12 col-sm-3 col-md-3 col-lg-3">
              <div className="section-point">
                <h3>{howitworkspoints[0].heading}</h3>
                <p>{howitworkspoints[0].paragraph}</p>
              </div>
            </div>
            <div className="col-12 col-sm-3 col-md-3 col-lg-3">
              <img src={arrowTop} alt="curly-arrow" />
            </div>
            <div className="col-12 col-sm-3 col-md-3 col-lg-3">
              <div className="section-point">
                <h3>{howitworkspoints[1].heading}</h3>
                <p>{howitworkspoints[1].paragraph}</p>
              </div>
            </div>
          </div>
          <div className="how-it-works-points row">
            <div className="col-12 col-sm-3 col-md-3 col-lg-3">
              <img src={arrowBottom} alt="curly-arrow" />
            </div>
            <div className="col-12 col-sm-3 col-md-3 col-lg-3">
              <div className="section-point">
                <h3>{howitworkspoints[2].heading}</h3>
                <p>{howitworkspoints[2].paragraph}</p>
              </div>
            </div>
            <div className="col-12 col-sm-3 col-md-3 col-lg-3">
              <img src={arrowBottom} alt="curly-arrow" />
            </div>
            <div className="col-12 col-sm-3 col-md-3 col-lg-3">
              <div className="section-point">
                <h3>{howitworkspoints[3].heading}</h3>
                <p>{howitworkspoints[3].paragraph}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
